// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("babel-polyfill");
import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App";
import router from "./router";
import axios from "axios";
import Moment from "moment";
import ElementUI, { Message } from "element-ui";
import login from "./assets/js/login";
import dict from "./assets/js/dict";
import api from "./assets/js/api";
import global from "./assets/js/global";
import "url-search-params-polyfill";
import echarts from "echarts";
import "babel-polyfill";
import Promise from "promise-polyfill";
import en from "./language/en";
import zh_CN from "./language/zh_CN";
import zh_TW from "./language/zh_TW";
import { preventReClick } from "./assets/js/preventReClick";
import divLoading from "./assets/js/xLoading";
import { JumpSeal,HandleNoLegalSeal } from "./assets/js/tools/tools";

Vue.use(VueI18n)
  .use(preventReClick)
  .use(divLoading);
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

Vue.use(Viewer);

// To add to window  解决promise 在ie中未定义的问题
if (!window.Promise) {
  window.Promise = Promise;
}
//icon
import "./assets/icon/iconfont.css";
import "./assets/icon2/iconfont.css";
import "./assets/icon3/iconfont.css";
//css
import "element-ui/lib/theme-chalk/index.css";
import "../static/css/style.css";

Vue.prototype.axios = axios;
Vue.prototype.moment = Moment;

Vue.prototype.dict = dict;
Vue.prototype.global = global;
Vue.prototype.$echarts = echarts;
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI);
window.Promise = Promise;
axios.defaults.withCredentials = true;
Vue.config.productionTip = false;

/**
 * 获取当前时间
 * 格式 YYYY-MM-DD HH:mm:ss
 */
Vue.prototype.getNowFormatDate = function() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }

  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }

  return (
    year +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds
  );
};

router.beforeEach((to, from, next) => {
  // document.getElementsByTagName('title')[0].innerHTML = global.parject;
  var path = to.path;
  var requiresAuth = to.meta.requiresAuth;

  // console.log(path + ' - ' + requiresAuth);
  if (requiresAuth) {
    if ("/index" === path) {
      /*login.hasAuth().then(res => {
          if (!res.data.ok && '999' === res.data.code) {
              // let loginOutUrl = sessionStorage.getItem("loginOutUrl");
              // window.location.href = loginOutUrl
              // router.push("/login");
              return false;
          }
      });*/
    } else {
      if (undefined !== to.meta.hasAuth && null != to.meta.hasAuth) {
        var currentUser = api.currentUser();
        if (undefined === currentUser || currentUser == null) {
          api.user.currentUserInfo().then(res => {
            if (null != res.data && res.data.ok) {
              currentUser = res.data.data;
              if (
                undefined === currentUser ||
                currentUser == null ||
                "" === currentUser
              ) {
                login.hasAuth().then(res => {
                  if (!res.data.ok && "999" === res.data.code) {
                    // router.push("/login");
                    return false;
                  }
                });
                return false;
              }
              sessionStorage.setItem(
                "currentUser",
                JSON.stringify(currentUser)
              );
            }
          });
        } else {
          var menuIdList = currentUser.menuIdList;
          if (undefined !== menuIdList && null != menuIdList) {
            var hasAuth = false;
            var menuIds = to.meta.hasAuth;

            // console.log("当前路由允许的菜单 IDS = " + menuIds);
            // console.log("当前用户拥有的菜单 IDS = " + menuIdList);

            for (var i = 0; i < menuIds.length; i++) {
              if (menuIdList.indexOf(menuIds[i]) !== -1) {
                hasAuth = true;
              }
            }

            // 校验其他路由页面当前用户是否有权限访问, 没有直接跳首页
            if (!hasAuth) {
              router.push("/index");
              return false;
            }
          }
        }
      }
    }

    next();
  } else {
    next();
  }
});
window._axiosPromiseArr = [];
// 拦截 request
axios.interceptors.request.use(
  config => {
    // 设置全局请求为 ajax 请求
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["access_token"] = sessionStorage.getItem("token") || "";
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel });
    });
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// 拦截响应 response, 并做一些错误处理
axios.interceptors.response.use(
  res => {
    // 返回的状态码和后台约定
    if (res.data.code === "999") {
      let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      if (!currentUser) {
        router.push("/login");
        return;
      }
      if (currentUser.currentServiceId == 2) {
        login.crcc16Url().then(res => {
          if (res.data.code == "0") {
            let url = res.data.data;
            window.location.href = url;
            // window.location.href = url;
          }
        });
      } else {
        router.push("/login");
      }
    } else if (res.data.code === "777") {
      // console.log(Vue,"???");
      //全局拦截 印章未授权提示
      HandleNoLegalSeal.showMsg(res.data)
    } else if (
      res.data.code === "200001" ||
      res.data.code === "400001" ||
      res.data.code === "300001" ||
      res.data.code === "100001"
    ) {
      Message.error({ message: res.data.message });
    } else {
      return res;
    }
  },
  err => {
    // 这里是返回状态码不为 200 时候的错误处理
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "请求错误";
          break;
        case 401:
          err.message = "未授权，请登录";
          break;
        case 403:
          err.message = "拒绝访问";
          break;
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`;
          break;
        case 408:
          err.message = "请求超时";
          break;
        case 500:
          err.message = "服务器内部错误";
          break;
        case 501:
          err.message = "服务未实现";
          break;
        case 502:
          err.message = "网关错误";
          break;
        case 503:
          err.message = "服务不可用";
          break;
        case 504:
          err.message = "网关超时";
          break;
        case 505:
          err.message = "HTTP版本不受支持";
          break;
        default:
      }
    }
    var originalRequest = err.config;
    if (
      err.code == "ECONNABORTED" &&
      err.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      //originalRequest._retry = true;
      //return axios.request(originalRequest);
      Message.error({ message: "请求超时!" });
    }
    return Promise.reject(err);
  }
);

function lang() {
  let t = window.localStorage.getItem("language");
  return t ? t : "zh_CN";
}

const language = lang();
window.lang = lang();
const i18n = new VueI18n({
  locale: language,
  messages: {
    en: en,
    zh_CN: zh_CN,
    zh_TW: zh_TW
  }
});

function getProjectName (){
  api.menu.getProjectName().then(res => {
    console.log(res, "????");
    sessionStorage.setItem("aesKey", res.data.data.aesKey);
    if (res.data.data.UMSPChgPsw) {
      sessionStorage.setItem("UMSPChgPsw", res.data.data.UMSPChgPsw);
      localStorage.setItem('showOnlineService', res.data.data.showOnlineService)
    }
    document.getElementsByTagName("title")[0].innerHTML =
      res.data.data.projectName;
  });
  return false;
}
const getPN = getProjectName()
/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  getPN,
  render: c => c(App), // 让 vue 知道我们的路由规则
  router: router, // 可以简写为 router
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js